import { DirectiveData, DirectiveUtilities } from 'alpinejs'
import DataLoader from 'dataloader'
import { renderCode } from '../lib/render-code.js'
import { runScript } from '../lib/run-script.js'
import { installWidget } from '../lib/install-widget.js'

export function htmlWidgetDirective(
  el: HTMLElement,
  { expression }: DirectiveData,
  { evaluateLater, effect }: DirectiveUtilities
) {
  const htmlLater = evaluateLater(expression)

  effect(() => {
    htmlLater(async (html: unknown) => {
      if (typeof html !== 'string') {
        return
      }

      let tplEl
      let tplChildNodes
      if (el.tagName?.toUpperCase() === 'SVG') {
        tplEl = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
        tplEl.innerHTML = html
        tplChildNodes = tplEl.childNodes
      } else {
        tplEl = document.createElement('template') as HTMLTemplateElement
        tplEl.innerHTML = html
        tplChildNodes = tplEl.content.childNodes
      }

      const widgets = collectWidgets(tplEl)
      const slottedWidgets = widgets.filter((w) => w.childElementCount && !w.hasAttribute('x-slotted'))
      if (slottedWidgets.length) {
        const slottedCode = slottedWidgets.map((w) => w.outerHTML).join('')
        const renderedSlottedCode = await renderCode(slottedCode)
        const resultDiv = document.createElement('div')
        resultDiv.innerHTML = renderedSlottedCode
        const replacements = Array.from(resultDiv.children).filter((c) => c.tagName.includes('-'))
        for (const scriptEl of resultDiv.querySelectorAll('script')) {
          await runScript(scriptEl)
        }

        for (const styleEl of resultDiv.querySelectorAll('style')) {
          document.body.append(styleEl)
        }
        replacements.forEach((replacement, index) => {
          console.assert(replacement.tagName === slottedWidgets[index].tagName, '')
          slottedWidgets[index].replaceWith(replacement)
        })
      }
      const widgetNames = widgets.reduce((widgetNames, widget) => {
        widgetNames.add(widget.tagName.toLowerCase())
        return widgetNames
      }, new Set<string>())
      const newWidgetNames = Array.from(widgetNames)
        // @ts-ignore
        .filter((name) => !WidgetElement.widgets.has(name))

      if (newWidgetNames.length) {
        await Promise.all(newWidgetNames.map((name) => installWidget(name)))
      }
      for (const widget of widgets) {
        const builder = widget.tagName
          .toLowerCase()
          .split('-')
          .map((str, i) => (i === 0 ? str : str[0].toUpperCase() + str.substring(1)))
          .join('')

        widget.setAttribute('x-data:widget', `${builder}($el)`)
      }

      if (el.tagName === 'TEMPLATE') {
        const content = Array.from(tplChildNodes)
        // @ts-ignore
        if (el._x_htmlAfter) {
          // @ts-ignore
          el._x_htmlAfter.forEach((e) => e.remove())
        }
        el.after(...content)
        // @ts-ignore
        el._x_htmlAfter = content
      } else {
        el.replaceChildren(...tplChildNodes)
      }
    })
  })
}

function collectWidgets(el: Element, collected: Element[] = []) {
  const tagName = el.tagName.toLowerCase()
  if (tagName.includes('-')) {
    collected.push(el)
    // @ts-ignore
    if (!WidgetElement.widgets.has(tagName)) {
      collected.push(el)
    }
  }

  if (tagName === 'template') {
    for (const childEl of (el as HTMLTemplateElement).content.children) {
      collectWidgets(childEl, collected)
    }
  } else {
    for (const childEl of el.children) {
      collectWidgets(childEl, collected)
    }
  }
  return collected
}
